import Container from "../components/ui/Container";
import MainSection from "../sections/contactus/MainSection";

export default function ContactUsPage() {
  return (
    <div>
      <MainSection />
    </div>
  );
}
